<template>
  <div class="toggle-arrow" @click="clicked()">
    <svg :id="'toggler_' + this._uid" class="toggle-arrow__svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 40">
      <polygon class="arrow svg-fill--gray-darkest" points="30 0 60 40 0 40"/>
    </svg>
  </div><!-- /.toggle-arrow -->
</template>

<script>
// import _ from 'lodash'
import SVG from 'svg.js'

export default {
  name: 'toggle-arrow',
  props: {
    closed: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      open: false,
      canvas: false
    }
  },
  mounted () {
    this.open = !this.closed
    this.canvas = SVG('toggler_' + this._uid)

    // Viewbox width is
    let svg = document.getElementById('toggler_' + this._uid)
    svg.style.height = parseFloat(this.width / 40 * 60) + 'px'
    svg.style.width = this.width + 'px'

    this.adjustRotation()
  },
  watch: {
    closed () {
      this.open = !this.closed
    },
    open () {
      this.adjustRotation()
    }
  },
  methods: {
    clicked () {
      this.open = !this.open
      this.$emit('toggle')
    },
    adjustRotation () {
      let rotation = !this.open ? -180 : 0
      let polygon = this.canvas.select('polygon')
      polygon.rotate(rotation, 30, 20)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/components/sass/shared/colors';
@import '~@/components/sass/shared/fonts';
@import '~@/components/sass/shared/helpers';

.toggle-arrow{
  height: 100%;
  justify-content: center;
  display: flex; -js-display: flex;
  align-items: center;
}

.toggle-arrow__svg{
  height: 4px; // 40
  width: 6px; // 60
}

.arrow{
  fill: $gray-darkest;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/shared/ToggleArrow.vue